var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0.5C10.184 0.5 1 9.684 1 21C1 32.316 10.184 41.5 21.5 41.5C32.816 41.5 42 32.316 42 21C42 9.684 32.816 0.5 21.5 0.5ZM31.012 14.44C30.7045 17.679 29.372 25.551 28.6955 29.1795C28.4085 30.717 27.8345 31.2295 27.3015 31.291C26.1125 31.3935 25.2105 30.512 24.0625 29.7535C22.2585 28.5645 21.2335 27.8265 19.491 26.6785C17.4615 25.346 18.7735 24.608 19.942 23.419C20.2495 23.1115 25.4975 18.335 25.6 17.9045C25.6142 17.8393 25.6123 17.7716 25.5945 17.7073C25.5766 17.643 25.5433 17.584 25.4975 17.5355C25.3745 17.433 25.2105 17.474 25.067 17.4945C24.8825 17.5355 22.0125 19.442 16.416 23.214C15.596 23.7675 14.858 24.0545 14.202 24.034C13.464 24.0135 12.07 23.624 11.0245 23.2755C9.733 22.8655 8.7285 22.64 8.8105 21.9225C8.8515 21.5535 9.364 21.1845 10.3275 20.795C16.3135 18.1915 20.2905 16.4695 22.279 15.6495C27.978 13.2715 29.1465 12.8615 29.9255 12.8615C30.0895 12.8615 30.479 12.9025 30.725 13.1075C30.93 13.2715 30.9915 13.497 31.012 13.661C30.9915 13.784 31.0325 14.153 31.012 14.44Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.0bf842899e0b9202ba2db34bff793cc9.svg";
export { ForwardRef as ReactComponent };